/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Schoolname_Eichendorffschule2Inputs */

const en__field__enum_schoolname_eichendorffschule2 = /** @type {(inputs: _Field__Enum_Schoolname_Eichendorffschule2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kelkheim`)
};

const de__field__enum_schoolname_eichendorffschule2 = /** @type {(inputs: _Field__Enum_Schoolname_Eichendorffschule2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eichendorffschule`)
};

/**
* | output |
* | --- |
* | "Kelkheim" |
*
* @param {_Field__Enum_Schoolname_Eichendorffschule2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_schoolname_eichendorffschule2 = /** @type {((inputs?: _Field__Enum_Schoolname_Eichendorffschule2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Schoolname_Eichendorffschule2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_schoolname_eichendorffschule2(inputs)
	return de__field__enum_schoolname_eichendorffschule2(inputs)
});
export { _field__enum_schoolname_eichendorffschule2 as "_field__enum_schoolName_Eichendorffschule" }